import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListingFaq } from '@components/listing-faq/models';
import { SvgComponent } from '@shared/components/svg';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { Faq } from '@shared/services/elastic-search/models';
import { LogsService } from '@shared/services/logs';
import { UrlParamsService } from '@shared/services/url-params';
import { take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-listing-faq',
  templateUrl: './listing-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, RouterLink],
})
export class ListingFaqComponent extends AbstractDynamicComponent<ListingFaq> {
  protected readonly faqs = signal<Faq[]>([]);
  private readonly elasticSearchService = inject(ElasticSearchService);
  private readonly urlParamsService = inject(UrlParamsService);
  private readonly logs = inject(LogsService);

  constructor() {
    super();
    effect(() => {
      const category = this.urlParamsService.param('categorie')();
      const includeOnlyFaqWithIds =
        this.data.includeOnlyFaqWithIds && this.data.includeOnlyFaqWithIds.length > 0
          ? this.data.includeOnlyFaqWithIds
          : undefined;
      this.elasticSearchService
        .getFaqs({
          includeOnlyFaqWithIds,
          excludeFaqWithQuestion: this.data.excludeFaqWithQuestion,
          ...(category ? { category } : {}),
        })
        .pipe(
          take(1),
          tap((faqs) => this.faqs.set(faqs))
        )
        .subscribe({ error: (err) => this.logs.error('ListingFaqComponent', 'getFaqs failed', err) });
    });
  }
}
